import App from '@/models/App'

export default class Traffic extends App {
    static get entity() {
        return 'traffics'
    }

    static one() {
        return this.query().withAllRecursive().first()
    }

    static fields() {
        return {
            hasAccount: this.attr(false),
            hasSharedSchedules: this.attr(false),
            isWindyOption: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/env/traffic`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'traffic',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
